<template>
  <div
    class="fullpagelist"
    v-keydowncustom="arrownav"
    v-hammer:pan.horizontal="panHandlerhorizontal"
    v-hammer:panend="onPanEnd"
  >
    <div class="forbeslogo">
      <a
        href="https://forbes.hu/"
        target="_blank"
      >
        <img
          src="../assets/forbes-yellow.svg"
          alt="Forbes"
        ></a>
    </div>
    <div
      class="btn back"
      v-show="$store.state.currentStep > 1"
    >
      <img
        v-on:click="stepBack"
        src="../assets/left-single.svg"
        alt="< Előző"
      >
    </div>
    <div
      class="btn next"
      v-show="$store.state.currentStep < $store.state.items.length"
    >
      <img
        v-on:click="stepNext"
        src="../assets/right-single.svg"
        alt="Következő >"
      >
    </div>
    <div class="itemcont">
      <div
        v-for="(item, key) in $store.state.items"
        :key="key"
        :class="'item '+item[1].slug+currentSlide(key)"
      >
        <transition :name="stepdirectionFam">
          <div
            v-show="$store.state.currentStep === key+1"
            class="iteminner"
          >
            <div
              class="imagecont"
              v-if="!item[1].ad"
            >
              <img
                :src="'./images/'+item[1].image[0]"
                :alt="item[0]"
              >
            </div>
            <h2
              class="familyname"
              v-if="!item[1].ad"
            >
              #{{item[1].displaynumber}} {{item[0]}}
            </h2>
            <div
              class="stitle"
              v-if="!item[1].ad"
            >
              {{item[1].alcím}}
            </div>
            <div
              class="sum"
              v-if="!item[1].ad"
            >
              Becsült érték: {{item[1].vagyon}} Ft
            </div>
            <div
              v-if="!item[1].ad"
              class="smallparts"
            >
              Központ: {{item[1].központ}} <span class="sep">|</span><br>
              Alapítva: {{item[1].alapítva}} <span class="sep">|</span><br>
              Generáció: {{item[1].generáció}}
            </div>
            <div
              class="substep back"
              v-on:click="stepBackSub"
              v-if="!item[1].ad"
            >
              <img
                src="../assets/prev-sub.svg"
                alt="< Előző"
              >
            </div>
            <div
              class="cardtextcont"
              v-if="!item[1].ad"
              v-mousewheel="mobilescroll"
            >
              <div class="mobileimg">
                <img
                  :src="'./images/'+item[1].image[0]"
                  :alt="item[0]"
                >
              </div>
              <div
                v-for="(item2, key2) in item[1].szoveg"
                :key="key2"
                class="cardtext"
                v-html="item2"
              >
                {{item2}}
              </div>
              <div
                class="backtofirst"
                v-if="$store.state.currentStep === $store.state.items.length"
                v-on:click="gotostart"
              ><img
                  src="../assets/left-double.svg"
                  alt="<<"
                >
                <span>Vissza az elejére</span>
              </div>
            </div>
            <div
              class="substep next"
              v-on:click="stepNextSub"
              v-if="!item[1].ad"
            >
              <img
                src="../assets/next-sub.svg"
                alt="Következő >"
              >
            </div>
            <div
              class="sponsor"
              v-if="item[1].ad === true"
            >
              <a
                :href="item[1].url"
                target="_blank"
              ><img
                  class="desktop"
                  :src="'./images/'+item[1].image[0]"
                  alt="Mercedes Benz"
                >
                <img
                  class="mobile"
                  :src="'./images/'+item[1].image[1]"
                  alt="Mercedes Benz"
                >
              </a>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import { VueHammer } from 'vue2-hammer';
import { setTimeout } from 'timers';

Vue.use(VueHammer);

// helped: https://github.com/bsdfzzzy/vue2-hammer/issues/23
VueHammer.config.pan = {
  direction: 6,
};
export default {
  name: 'Fullpagelist',
  props: {
  },
  directives: {
    mousewheel: {
      // passive listener for performance improvement
      inserted: (el, binding) => {
        const f = (evt) => {
          if (binding.value(evt, el)) {
            el.removeEventListener('wheel', f, { passive: true });
            el.removeEventListener('scroll', f, { passive: true });
          }
        };
        el.addEventListener('wheel', f, { passive: true });
        el.addEventListener('scroll', f, { passive: true });
      },
    },
    keydowncustom: {
      inserted: (el, binding) => {
        const f = (evt) => {
          if (binding.value(evt, el)) {
            document.removeEventListener('keydown', f, { passive: true });
          }
        };
        document.addEventListener('keydown', f, { passive: true });
      },
    },
  },
  data() {
    return {
      stepdirectionFam: '',
    };
  },
  methods: {
    ...mapActions([
      'decrement',
      'increment',
    ]),
    stepBack() {
      this.$store.dispatch('decrement');
      this.stepdirectionFam = 'slideleft';
    },
    stepNext() {
      this.$store.dispatch('increment');
      this.stepdirectionFam = 'slideright';
    },
    stepBackSub() {
      document.querySelector('.item.active .cardtextcont').scrollBy(0, -20);
    },
    stepNextSub() {
      document.querySelector('.item.active .cardtextcont').scrollBy(0, 20);
    },
    currentSlide(key) {
      if (this.$store.state.currentStep === key + 1) {
        return ' active';
      }
      return '';
    },
    handleRouteParams(slug) {
      if (slug) {
        const sluggot = slug;
        this.$store.state.currentStep = this.$store.state.slugs.indexOf(sluggot) + 1;
      }
    },
    mobilescroll(evt) {
      const element = evt.target;
      if (element.scrollHeight !== element.clientHeight) {
        // lefelé görgetek elértem a végét
        if (element.scrollHeight - element.scrollTop - element.clientHeight < 1) {
          element.closest('.item').classList.remove('showup');
          element.closest('.item').classList.add('hidedown');
        } else {
          element.closest('.item').classList.remove('hidedown');
        }
        if (element.scrollTop === 0) {
          element.closest('.item').classList.remove('showup');
        } else {
          element.closest('.item').classList.add('showup');
        }
      }
      if (element.scrollHeight === element.clientHeight) {
        element.closest('.item').classList.add('hidedown');
      }
    },
    arrownav(evt) {
      if (evt.key === 'ArrowLeft' || evt.key === 'Left') {
        this.stepBack();
      }
      if (evt.key === 'ArrowRight' || evt.key === 'Right') {
        this.stepNext();
      }
    },
    panHandlerhorizontal(e) {
      if (e.offsetDirection === 4) {
        // e.target.closest('.item').style.transform = `translateX(${e.distance}px)`;
        document.querySelector('.item.active').style.transform = `translateX(${e.distance}px)`;
        document.querySelector('.btn.back').classList.add('active');
      }
      if (e.offsetDirection === 2) {
        // e.target.closest('.item').style.transform = `translateX(-${e.distance}px)`;
        document.querySelector('.item.active').style.transform = `translateX(-${e.distance}px)`;
        document.querySelector('.btn.next').classList.add('active');
      }
    },
    onPanEnd(e) {
      if (e.distance > 50 && e.direction === 4) {
        this.stepBack();
      } else {
        document.querySelector('.item.active').style.transform = 'translateX(0px)';
      }
      if (e.distance > 50 && e.direction === 2) {
        this.stepNext();
      } else {
        document.querySelector('.item.active').style.transform = 'translateX(0px)';
      }
      document.querySelector('.btn.back').classList.remove('active');
      document.querySelector('.btn.next').classList.remove('active');
    },
    gotoPage() {
      if (this.$route.params.slug) {
        setTimeout(() => {
          this.$store.state.currentStep = (
            this.$store.state.slugs.indexOf(this.$route.params.slug)
          ) + 1;
        }, 3000);
      }
    },
    gotostart() {
      this.$store.state.currentStep = 1;
    },
  },
  created() {
    this.gotoPage();
  },
  mounted() {
  },
  computed: {
    ...mapState(['items', 'currentStep']),
  },
  watch: {
    currentStep(newValue/* , oldValue */) {
      if (newValue) {
        this.$router.push({ name: 'Listaelem', params: { slug: this.$store.state.items[newValue - 1][1].slug } });
      } else {
        this.$store.state.currentStep = 1;
      }
    },
    $route(to/* , from */) {
      this.handleRouteParams(to.params.slug);
    },
  },
};
</script>

<style scoped lang="css">
.fullpagelist {
  min-height: calc(100vh - 280px);
  padding-bottom: 40px;
  display: grid;
  grid-template-columns: 125px 1fr 50px 1fr 125px;
  grid-template-rows: 150px auto;
  display: -ms-grid;
  -ms-grid-columns: 125px 1fr 50px 1fr 125px;
  -ms-grid-rows: 150px auto;
  position: relative;
}
.forbeslogo {
  align-self: end;
  justify-self: center;
  padding-bottom: 25px;
  grid-column: 2/3;
  grid-row: 1/2;
  -ms-grid-column: 2;
  -ms-grid-row: 1;
}
.forbeslogo img {
  height: 21px;
}
.btn {
  cursor: pointer;
  transition: all 1s;
  -ms-grid-row-align: center;
  text-align: center;
}
.btn:hover {
  transform: scale(1.5);
}
.back {
  grid-column: 1/2;
  grid-row: 2/3;
  -ms-grid-column: 1;
  -ms-grid-row: 2;
  align-self: center;
  justify-self: center;
}
.next {
  grid-column: 5/6;
  grid-row: 2/3;
  -ms-grid-column: 5;
  -ms-grid-row: 2;
  align-self: center;
  justify-self: center;
}
.back img,
.next img {
  width: 25px;
}
.itemcont {
  grid-row: 2/3;
  grid-column: 2/5;
  -ms-grid-column-span: 3;
  -ms-grid-column: 2;
  -ms-grid-row: 2;
  min-height: 180px;
}
.item {
  position: relative;
  overflow: hidden;
  min-height: 180px;
  display: none;
}
.item.active {
  z-index: 2;
  display: block;
  transform: translateX(0px);
}
.iteminner {
  display: grid;
  grid-template-columns: auto 50px 1fr;
  grid-template-rows: auto auto auto auto auto 1fr auto;
  display: -ms-grid;
  -ms-grid-columns: auto 50px 1fr;
  -ms-grid-rows: auto auto auto auto auto 1fr auto;
}
.imagecont {
  grid-column: 1/2;
  grid-row: 1/8;
  -ms-grid-column: 1;
  -ms-grid-row-span: 7;
}
.imagecont img {
  height: 100%;
}
.familyname {
  font-family: "Cardo", serif;
  font-weight: 700;
  font-size: 30px;
  margin: 0 0 30px 0;
  text-transform: uppercase;
  grid-column: 3/4;
  grid-row: 1/2;
  -ms-grid-column: 3;
  -ms-grid-row: 1;
}
.stitle,
.sum {
  font-size: 24px;
  line-height: 1.2;
}
.stitle {
  color: #e2af25;
  grid-column: 3/4;
  grid-row: 2/3;
  -ms-grid-column: 3;
  -ms-grid-row: 2;
}
.sum {
  grid-column: 3/4;
  grid-row: 3/4;
  -ms-grid-column: 3;
  -ms-grid-row: 3;
}
.smallparts {
  grid-column: 3/4;
  grid-row: 4/5;
  -ms-grid-column: 3;
  -ms-grid-row: 4;
  font-size: 20px;
  line-height: 1.2;
  margin-bottom: 20px;
}
.smallparts br {
  display: none;
}
.sep {
  margin: 0 10px;
  color: #e2af25;
}
.substep.back {
  margin-bottom: 10px;
  grid-column: 3/4;
  grid-row: 5/6;
  -ms-grid-column: 3;
  -ms-grid-row: 5;
}
.cardtextcont {
  overflow-y: scroll;
  position: relative;
  grid-column: 3/4;
  grid-row: 6/7;
  -ms-grid-column: 3;
  -ms-grid-row: 6;
}
.cardtext {
  font-size: 14px;
  line-height: 2;
  width: 100%;
}
.cardtext:before {
  content: '•';
  display: inline-block;
  width: 10px;
  height: 10px;
}
.cardtext:not(:last-child) {
  margin-bottom: 10px;
}
.cardtextcont {
  height: 180px;
}
.substep {
  visibility: hidden;
  cursor: pointer;
  transition: transform 1s;
}
.substep:hover,
.substep:focus {
  transform: scale(1.5);
}
.substep.show {
  visibility: visible;
}
.substep img {
  width: 25px;
  margin: 0 auto;
  display: block;
}
.substep.next {
  margin-top: 10px;
  grid-column: 3/4;
  grid-row: 7/8;
  -ms-grid-column: 3;
  -ms-grid-row: 7;
}
.sponsor {
  grid-column: 1/4;
  grid-row: 1/7;
  -ms-grid-column-span: 3;
  -ms-grid-row-span: 6;
}
.sponsor a {
  display: block;
}
.sponsor img {
  width: 100%;
  height: auto;
}
.cardtext.active {
  display: initial;
}
.slideleft-leave-active,
.slideleft-enter-active,
.slideright-leave-active,
.slideright-enter-active {
  transition: 1s;
}
.slideleft-enter-active {
  position: absolute;
  top: 0;
}
.slideleft-enter {
  transform: translate(-100%, 0);
}
.slideleft-leave-to {
  transform: translate(100%, 0);
}
.slideright-enter {
  transform: translate(100%, 0);
}
.slideright-leave-to {
  transform: translate(-100%, 0);
}
.slideleft-leave-to,
.slideleft-leave-active,
.slideright-leave-to,
.slideright-leave-active {
  position: absolute;
  top: 0px;
}
.mobileimg {
  display: none;
}
.sponsor .mobile {
  display: none;
}
.showup .substep.back {
  visibility: visible;
}
.hidedown .substep.next {
  visibility: hidden;
}
.substep.next {
  visibility: visible;
}
.backtofirst {
  margin: 40px auto 0 auto;
  width: fit-content;
  font-weight: 700;
  color: #e2af25;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.backtofirst img {
  width: 20px;
  margin-right: 10px;
}
@media screen and (max-width: 1366px) {
  .fullpagelist {
    grid-template-columns: 90px 1fr 50px 1fr 90px;
    -ms-grid-columns: 90px 1fr 50px 1fr 90px;
    grid-template-rows: 100px auto;
    -ms-grid-rows: 100px auto;
  }
  .familyname {
    margin: 0 0 20px 0;
  }
}
@media screen and (min-width: 768px) {
  .slideup-leave-active,
  .slideup-enter-active,
  .slidedown-leave-active,
  .slidedown-enter-active {
    transition: all 1s;
  }
  .slideup-enter {
    transform: translate(0, -100%);
  }
  .slideup-leave-to {
    transform: translate(0, 100%);
  }
  .slidedown-enter {
    transform: translate(0, 100%);
  }
  .slidedown-leave-to {
    transform: translate(0, -100%);
  }
  .cardtextcont {
    margin-right: -20px;
    padding-right: 20px;
  }
}
@media screen and (max-width: 767px) {
  .fullpagelist {
    grid-template-columns: 30px 1fr 50px 1fr 30px;
    -ms-grid-columns: 30px 1fr 50px 1fr 30px;
    padding-bottom: 20px;
    min-height: calc(100vh - 260px);
    grid-template-rows: auto auto;
    -ms-grid-rows: auto auto;
    touch-action: pan-y !important;
  }
  .forbeslogo {
    padding: 25px 0;
  }
  .back img,
  .next img {
    width: 20px;
  }
  .btn:hover {
    transform: scale(1);
  }
  .btn.active {
    transform: scale(1.5);
  }
  .iteminner {
    grid-template-columns: 1fr;
    -ms-grid-columns: 1fr;
    padding: 0 15px;
    grid-template-rows: auto auto auto auto auto auto auto;
    -ms-grid-rows: auto auto auto auto auto auto auto;
  }
  .familyname,
  .stitle,
  .sum,
  .smallparts,
  .substep.back,
  .cardtextcont,
  .substep.next {
    grid-column: 1/2;
    -ms-grid-column: 1;
  }
  .imagecont {
    display: none;
  }
  .cardtextcont {
    overflow-y: scroll;
    height: 100%;
  }
  .mobileimg {
    display: block;
    margin-bottom: 10px;
  }
  .mobileimg img {
    width: 100%;
  }
  .sponsor .mobile {
    display: initial;
  }
  .sponsor .desktop {
    display: none;
  }
  .smallparts br {
    display: initial;
  }
  .sep {
    display: none;
  }
}
</style>
<style>
.cardtext a {
  color: #fff;
}
</style>
